// Preload hero collage LCP images as early as possible.
// Imported for its side effect at app bootstrap so the browser starts
// fetching the polaroid tiles before React renders the collage.
import noCapUrl from "@/assets/businesses/no-cap.png?url";
import lockedUrl from "@/assets/businesses/locked.png?url";

if (typeof document !== "undefined") {
  for (const href of [noCapUrl, lockedUrl]) {
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = href;
    // fetchpriority is a valid attribute; cast for TS DOM lib versions.
    (link as HTMLLinkElement & { fetchPriority?: string }).fetchPriority = "high";
    document.head.appendChild(link);
  }
}